import React, { memo, type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { theme, TitleText } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PermissionsPromptTitle = memo((props: PropsWithChildren) => {
  return (
    <TitleText sizeMatch={['48']} style={styles.title}>
      {props.children}
    </TitleText>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  title: {
    color: theme.colors.CREAM,
    marginBottom: theme.spacing['4'],
  },
});
